import { Fragment, useState } from 'react';
import { Trans } from '@lingui/react/macro';
import { TableBodyCell, Menu, IconButton } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { ConfirmDeleteUserDialog } from 'app/domains/users/components/ConfirmDeleteUserDialog';
import { useRole } from 'app/domains/users/hooks/useRole';
import { getTableHeaders } from '../../../../utils/tableHeaders';
export function ContextCell(props) {
    const tableHeaders = getTableHeaders();
    const { stickyColumn, id, name, isSelf, role } = props;
    const userRole = useRole();
    const [confirmDialog, setConfirmDialog] = useState(false);
    const hasLowerRoleLevel = role === 'owner' && userRole.has('admin');
    const isDisabled = !userRole.can('invite:user') || isSelf || hasLowerRoleLevel;
    const handleDelete = () => {
        setConfirmDialog(true);
    };
    if (!userRole.can('delete:user')) {
        return null;
    }
    return (<Fragment>
      <TableBodyCell removeExtraPadding stickyColumn={stickyColumn} headers={tableHeaders.action.id}>
        <Menu.Root target={<IconButton appearance="ghost" size="xs" disabled={isDisabled}>
              <Falcon icon="ellipsis-h"/>
            </IconButton>}>
          <Menu.Item onClick={handleDelete}>
            <Falcon icon="trash"/>
            <Trans comment="users table dropdown menu - delete user list item">Delete user</Trans>
          </Menu.Item>
        </Menu.Root>
      </TableBodyCell>
      {confirmDialog && <ConfirmDeleteUserDialog onClose={() => setConfirmDialog(false)} id={id} name={name}/>}
    </Fragment>);
}
